import { useLayoutEffect } from 'react'

const BRAND = 'Canopy'

/** Build a concise, consistently branded browser title from visible content. */
export function formatDocumentTitle(
  ...parts: ReadonlyArray<string | null | undefined>
): string {
  const content = parts
    .map((part) => part?.trim())
    .filter((part): part is string => !!part)
  return [...content, BRAND].join(' · ')
}

/** Update the document title before paint, without rewriting an unchanged title. */
export function DocumentTitle({ children }: { children?: string | null }) {
  const title = formatDocumentTitle(children)
  useLayoutEffect(() => {
    if (document.title !== title) document.title = title
  }, [title])
  return null
}
